module.exports = __webpack_public_path__ + "static/media/general-bikeShelter.fda6c6f9.png";